import { useMutation, useQuery } from "@tanstack/react-query";
import axiosBaseURL from "..";
import { useAuth, AuthContextValue } from "../../providers/AuthProvider";

export const useGetAllProducts = () => {
  const { authString, user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["get all products"],
    staleTime: 120,
    queryFn: async () => {
      const result = await axiosBaseURL.get(`/off-taker/order/create`, {
        headers: {
          header: `${user?.userId}/${user?.token}`,
          Authorization: authString,
        },
      });

      return result;
    },
  });
};

// export const useCreateOrder = () => {
//     const { refetch } = useMyOrderList();
//     const { user } = useAuth() as AuthContextValue;

//     return useMutation({
//         mutationFn: async (order: any ) => {
//             order.org_Id = user?.mfiId;
//             order.land_size = undefined;
//             const result =  await axiosBaseURL.post(`/off-taker/createOrder/`, order, {
//                 headers: {
//                     header: `${user?.userId}/${user?.token}`,
//                 }
//             });

//             refetch();
//             return result;
//         }
//     })
// };
export const useProductTypeList = () => {
  const { authString, user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["product type"],
    staleTime: 120,
    queryFn: async () => {
      // const result = await axiosBaseURL.get(`/product/types`, {
      //     headers: {
      //         header: `${user?.userId}/${user?.token}`,
      //         Authorization: authString,
      //     }
      // });

      return {
        status: "success",
        message: "message",
        length: 4,
        data: ["Crop", "Vegitable"],
      };
    },
  });
};

export const useProductList = (searchKey?: string) => {
  const { authString, user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["product list", searchKey],
    staleTime: 120,
    queryFn: async () => {
      const queryString = searchKey ? `?search=${searchKey}` : "";
      const result = await axiosBaseURL.get(`/off-taker/product`, {
        headers: {
          header: `${user?.userId}/${user?.token}`,
          Authorization: authString,
        },
      });

      return result;
    },
  });
};

export const useGetProductById = (id: string) => {
  const { authString, user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["product by id", id],
    staleTime: 120,
    queryFn: async () => {
      const result = await axiosBaseURL.get(`/off-taker/product/${id}`, {
        headers: {
          header: `${user?.userId}/${user?.token}`,
          Authorization: authString,
        },
      });

      return result;
    },
  });
};

export const useGetProductsByType = (type: string) => {
  const { authString, user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["product types", type],
    staleTime: 120,
    queryFn: async () => {
      // const result = await axiosBaseURL.get(`/product-type/type`, {
      //     headers: {
      //         header: `${user?.userId}/${user?.token}`,
      //         Authorization: authString,
      //     }
      // });

      return {
        status: "success",
        message: "message",
        data: {
          id: 1,
          category: "Vegitable",
          productName: "Potato",
          variety: "Gudene",
          detail: { color: "Yellow", size: "Medium" },
        },
      };
    },
  });
};

export const useCreateProduct = () => {
  const { refetch } = useProductList();
  const { authString, user } = useAuth() as AuthContextValue;
  return useMutation({
    mutationFn: async (product: any) => {
      const result = await axiosBaseURL.post(`/off-taker/product`, product, {
        headers: {
          header: `${user?.userId}/${user?.token}`,
        },
      });
      refetch();
      return result;
    },
  });
};

export const useUpdateProduct = () => {
  const { user } = useAuth() as AuthContextValue;
  const { refetch } = useProductList();
  return useMutation({
    mutationFn: async (data: any) => {
      const result = await axiosBaseURL.patch(
        `/off-taker/product/${data.id}`,
        data.product,
        {
          headers: {
            header: `${user?.userId}/${user?.token}`,
          },
        },
      );

      refetch();
      return result;
    },
  });
};

export const useDeleteProduct = () => {
  const { user } = useAuth() as AuthContextValue;
  const { refetch } = useProductList();
  return useMutation({
    mutationFn: async (id: string) => {
      const result = await axiosBaseURL.delete(`/off-taker/product/${id}`, {
        headers: {
          header: `${user?.userId}/${user?.token}`,
        },
      });

      refetch();
      return result;
    },
  });
};
